// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__tNi4C","large":"styles_large__2qEhL"};